import { __extends } from "tslib";
import { ErrorEvent } from './ErrorEvent';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: IOErrorEvent
var IOErrorEvent = /** @class */ (function (_super) {
    __extends(IOErrorEvent, _super);
    function IOErrorEvent(type, bubbles, cancelable, text, id) {
        if (bubbles === void 0) { bubbles = false; }
        if (cancelable === void 0) { cancelable = false; }
        if (text === void 0) { text = ''; }
        if (id === void 0) { id = 0; }
        return _super.call(this, type, bubbles, cancelable, text, id) || this;
    }
    IOErrorEvent.prototype.clone = function () {
        var event = new IOErrorEvent(this.type, this.bubbles, this.cancelable, this.text, this.errorID);
        //this.copyNativeData(event);
        return event;
    };
    IOErrorEvent.prototype.toString = function () {
        return this.formatToString('IOErrorEvent', 'type', 'bubbles', 'cancelable', 'text', 'errorID');
    };
    IOErrorEvent.classInitializer = null;
    IOErrorEvent.classSymbols = null;
    IOErrorEvent.instanceSymbols = null;
    // JS -> AS Bindings
    IOErrorEvent.IO_ERROR = 'ioError';
    IOErrorEvent.NETWORK_ERROR = 'networkError';
    IOErrorEvent.DISK_ERROR = 'diskError';
    IOErrorEvent.VERIFY_ERROR = 'verifyError';
    return IOErrorEvent;
}(ErrorEvent));
export { IOErrorEvent };
